import React from 'react'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import { useStore } from 'store/context'
import * as SideMenu from 'components/side-menu'

export const ArchivedCheckinsLink = () => {
  const { currentUser } = useStore()
  const isAdminOrManager = currentUser?.isAdmin || currentUser?.isManager
  const path = isAdminOrManager
    ? '/check-ins/archived'
    : `/check-ins/archived/${currentUser?.id}`
  const title = 'Archived'

  return (
    <SideMenu.LinkItem
      active={useIsActive(path, null, { exactMatch: false })}
      analyticsProps={sideNavAnalyticsProps({
        title,
        href: path,
      })}
      href={path}
    >
      {title}
    </SideMenu.LinkItem>
  )
}
